/**
 * TODO The /new prefix can be removed once the old QDrive is no longer in use.
 *      These constants can then also be used in the route definition below.
 */
export enum MainRoutes {
  DEFAULT = '/new',
  HANDOVER = '/new/handover',
  NEW_DRIVER_APP = '/new/driver',
  DRIVER_NAME = '/new/driver/name',
  SHIFT = '/new/shift',
  ACCOUNT = '/new/account',
  ADMIN = '/new/admin',
  UNAUTHORIZED = '/new/unauthorized',
  LOGOUT = '/new/logout',

  /**
   * @deprecated TODO : should no longer be in use in PROD, kept as it is still referenced by the legacy code
   */
  OLD_DRIVER_APP = '/tours',
  /**
   * @deprecated TODO : should no longer be in use in PROD, kept as it is still referenced by the legacy code
   */
  LEGACY_SHIFTS = '/shift'
}
